export class GetCategoriesAction {
  static type = '[CATEGORY] Get categories';
}
